import React from 'react';

const features = [
  {
    icon: '📂',
    color: 'bg-blue-100 text-blue-600',
    title: 'Catégorisation intelligente',
    desc: 'Organisez vos contacts par catégories personnalisées & tags intelligents',
  },
  {
    icon: '🗓️',
    color: 'bg-purple-100 text-purple-600',
    title: "Timeline d'événements",
    desc: 'Gardez une trace de tous vos échanges et moments importants',
  },
  {
    icon: '⏰',
    color: 'bg-cyan-100 text-cyan-600',
    title: 'Rappels intelligents',
    desc: 'Recevez des suggestions de relance au bon moment',
  },
  {
    icon: '🗺️',
    color: 'bg-pink-100 text-pink-600',
    title: 'Cartographie relationnelle',
    desc: 'Visualisez votre réseau et découvrez de nouvelles connexions',
  },
  {
    icon: '🤖',
    color: 'bg-green-100 text-green-600',
    title: 'Suggestions IA',
    desc: 'L’IA vous propose des interactions et mises en relation pertinentes',
  },
  {
    icon: '📊',
    color: 'bg-orange-100 text-orange-600',
    title: 'Statistiques',
    desc: 'Mesurez l’impact de vos interactions et votre évolution',
  },
];

function Features() {
  return (
    <section className="bg-[#f7fafd] py-20 px-4 md:px-0" id="features">
      <h2 className="text-3xl font-bold text-blue-900 text-center mb-2">Fonctionnalités clés</h2>
      <p className="text-center text-blue-700 max-w-2xl mx-auto mb-10">Tout ce dont vous avez besoin pour gérer vos relations efficacement</p>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {features.map((f) => (
          <div key={f.title} className="bg-white rounded-2xl shadow p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 hover:shadow-xl animate-fadeIn">
            <span className={`text-3xl mb-3 w-12 h-12 flex items-center justify-center rounded-full ${f.color}`}>{f.icon}</span>
            <h3 className="font-semibold text-blue-900 mb-1 text-center">{f.title}</h3>
            <p className="text-blue-700 text-center text-sm">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features; 